import React from "react";

export default function Footer() {
	return (
		<div className="waFooter">
			<div className="inner">
				<div className="fixedWidth">
					<Top />
					<Menu />
				</div>
			</div>

			<Icons />
			<Bottom />
		</div>
	);
}

function Top(){
	return (
		<div className="top">
			<div className="logo desktop">
				<a href="https://www.wildapricot.com/">
					<img alt="Membership Software - WildApricot" title="Membership Software - WildApricot" src="https://s.wildapricot.net/StaticImages/v7/Logo/WildApricotTransparent.png" />
				</a>
			</div>

			<div className="logo mobile">
				<a href="https://www.wildapricot.com/">
					<img alt="Membership Software - WildApricot" title="Membership Software - WildApricot" src="https://s.wildapricot.net/StaticImages/v7/Logo/WildApricotTransparent.png" />
				</a>
			</div>

			<div className="contact">
				<div className="address-icon fa fa-map-marker-alt"></div>
				<address>WildApricot Inc.&nbsp;<br />144 Front Street West&nbsp;<br />Suite 725&nbsp;<br />Toronto, Ontario M5J 2L7&nbsp;<br />Canada</address>
			</div>
		</div>
	);
}

function Menu(){
	return (
		<div className="menuFooterContainer menuContainer">
			<div className="menuFooter menu">
				<div className="menuLevel1 static current">
					<div className="inner">
						<ul>
							<li className="other itemLevel1 static dynamic"><a href="https://www.wildapricot.com/about-us"><span>About</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a>
								<div className="menuLevel2 dynamic other">
									<div className="inner">
										<ul>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/about-us"><span>Company</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/meet-the-apricots"><span>Our Team</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/partner-program"><span>Partner &amp; Affiliate Programs</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://personifycorp.com/about-us/job-listings"><span>Careers</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/terms-and-policies"><span>Terms and Policies</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/wild-apricot-security"><span>Security</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/membership-software-recommendation"><span>Recommend WildApricot</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://personifycorp.com/products" target="_blank"><span>Personify Portfolio</span></a></li>
										</ul>
									</div>
								</div>
							</li>
							<li className="other itemLevel1 static dynamic"><a href="https://www.wildapricot.com/blogs/newsblog"><span>Blog</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a>
								<div className="menuLevel2 dynamic other">
									<div className="inner">
										<ul>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/membership"><span>Membership</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/events"><span>Events</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/website-and-technology"><span>Website &amp; Technology</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/fundraising"><span>Fundraising</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/volunteerism"><span>Volunteerism</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/marketing"><span>Marketing</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/organizational-management"><span>Organizational Management</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/blog/wild-apricot-updates"><span>WildApricot Updates</span></a></li>
										</ul>
									</div>
								</div>
							</li>
							<li className="other itemLevel1 static dynamic"><a href="https://forums.wildapricot.com/"><span>Forums</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a>
								<div className="menuLevel2 dynamic other">
									<div className="inner">
										<ul>
											<li className="other itemLevel2 static dynamic"><a href="https://forums.wildapricot.com/forums/308932-wishlist"><span>Wishlist</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://forums.wildapricot.com/forums/308926-designers"><span>Designers</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://forums.wildapricot.com/forums/309658-developers"><span>Developers</span></a></li>
										</ul>
									</div>
								</div>
							</li>
							<li className="current itemLevel1 static dynamic"><a href="https://gethelp.wildapricot.com/"><span>Help</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a>
								<div className="menuLevel2 dynamic current">
									<div className="inner">
										<ul>
											<li className="current itemLevel2 static dynamic"><a href="https://gethelp.wildapricot.com/"><span>Help Center</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://support.wildapricot.com/"><span>Support Portal</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://forums.wildapricot.com/forums/308923-service-notices"><span>Service Notices</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/partners"><span>Partner Directory</span></a></li>
										</ul>
									</div>
								</div>
							</li>
							<li className="other itemLevel1 static dynamic"><a><span>Resource Library</span><i className="fas fa-chevron-up"></i><i className="fas fa-chevron-down"></i><i className="fas fa-chevron-left"></i><i className="fas fa-chevron-right"></i></a>
								<div className="menuLevel2 dynamic other">
									<div className="inner">
										<ul>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/resource-library#ebooks"><span>eBooks</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/resource-library#research-reports"><span>Research Reports</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/resource-library#templates"><span>Templates</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/resource-library#checklists"><span>Checklists</span></a></li>
											<li className="other itemLevel2 static dynamic"><a href="https://www.wildapricot.com/resource-library#slide-decks"><span>Slide Decks</span></a></li>
										</ul>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

function Icons() {
	return (
		<div className="icons">
			<div className="fixedWidth">
				<a target="_blank" className="icon icon-facebook" data-social-name="Facebook" title="WildApricot on Facebook" href="https://www.facebook.com/wildapricot"><i className="fab fa-facebook-f"></i></a>
				<a target="_blank" className="icon icon-twitter" data-social-name="Twitter" title="WildApricot on Twitter" href="https://twitter.com/wildapricot"><i className="fab fa-twitter"></i></a>
				<a target="_blank" className="icon icon-linkedin" data-social-name="LinkedIn" title="WildApricot on LinkedIn" href="https://www.linkedin.com/company/wild-apricot"><i className="fab fa-linkedin-in"></i></a>
				<a target="_blank" className="icon icon-youtube" data-social-name="Youtube" title="WildApricot on Youtube" href="https://www.youtube.com/wildapricotcom"><i className="fab fa-youtube"></i></a>
				<a target="_blank" className="icon icon-pinterest" data-social-name="Pinterest" title="WildApricot on Pinterest" href="https://pinterest.com/wildapricot/"><i className="fab fa-pinterest"></i></a>
				<a target="_blank" className="icon icon-rss" data-social-name="RSS" title="WildApricot on RSS" href="https://feeds.feedburner.com/WildApricot"><i className="fas fa-wifi"></i></a>
				<div className="grow expander"></div>
				<div className="elevio">
					<a href="https://elev.io/referral?utm_source=customer&amp;utm_medium=kb&amp;utm_term=v1&amp;utm_content=Powered%20by%20elev.io&amp;utm_campaign=5937fe412bf99" target="_blank">Powered&nbsp;by&nbsp;<svg viewBox="0 0 247 70">
						<g>
							<path d="M246.818259,43.5437116 C246.818259,30.3037974 236.08595,19.5714881 222.846036,19.5714881 C209.606979,19.5714881 198.874669,30.3037974 198.874669,43.5437116 C198.874669,56.7827688 209.606979,67.515078 222.846036,67.515078 C224.018423,67.515078 225.170241,67.4310912 226.297206,67.2682597 L213.531218,54.5031279 C210.430563,51.8652577 208.462873,47.9341628 208.462873,43.5437116 C208.462873,35.5992489 214.90243,29.1605489 222.846036,29.1605489 C230.789642,29.1605489 237.230055,35.5992489 237.230055,43.5437116 C237.230055,50.9311192 231.659504,57.0175889 224.489777,57.8326034 L232.255125,65.5979514 C232.258553,65.5970944 232.261981,65.5953804 232.265409,65.5936664 L236.792981,70.1220959 L236.792981,63.042354 C242.863168,58.6921822 246.818259,51.5798741 246.818259,43.5437116"></path>
							<polyline points="127.74 20.874 139.424 20.874 150.935 47.764 162.447 20.874 174.045 20.874 154.629 66.491 147.242 66.491 127.74 20.874"></polyline>
							<path d="M34.2768857 53.9486438C31.3827703 56.4348236 28.295828 57.5566468 23.8813806 57.5566468 17.3526948 57.5566468 12.1986497 53.7763852 11.0819684 46.9897401L47.850176 46.9897401C47.850176 45.9587597 47.9358768 45.444555 47.9358768 44.4127175 47.9358768 29.9807054 38.1419911 19.6717581 23.709979 19.6717581 9.02000756 19.6717581-.68434189e-14 31.1830874-.68434189e-14 43.6396965-.68434189e-14 57.0415851 9.36366771 67.6933356 23.8813806 67.6933356 31.573026 67.6933356 37.2318488 65.7145045 41.6951457 61.3669037L34.2768857 53.9486438zM23.8813806 29.3790859C29.9807054 29.3790859 34.8776482 32.6434288 36.4245474 37.9697326L11.5970302 37.9697326C13.8303926 32.2140679 18.2122737 29.3790859 23.8813806 29.3790859zM109.873548 53.9486438C106.979432 56.4348236 103.89249 57.5566468 99.4780426 57.5566468 92.9493568 57.5566468 87.7944546 53.7763852 86.6777734 46.9897401L123.445981 46.9897401C123.445981 45.9587597 123.531682 45.444555 123.531682 44.4127175 123.531682 29.9807054 113.737796 19.6717581 99.306641 19.6717581 84.6158125 19.6717581 75.596662 31.1830874 75.596662 43.6396965 75.596662 57.0415851 84.9594727 67.6933356 99.4780426 67.6933356 107.169688 67.6933356 112.828511 65.7145045 117.290951 61.3669037L109.873548 53.9486438zM99.4780426 29.3790859C105.577367 29.3790859 110.47431 32.6434288 112.020352 37.9697326L87.1928351 37.9697326C89.4270546 32.2140679 93.8080787 29.3790859 99.4780426 29.3790859z"></path>
							<polyline points="55.925 0 55.925 66.491 67.35 66.491 67.35 11.426 55.925 0"></polyline>
							<polyline points="179.903 20.874 179.628 20.874 179.628 66.491 191.054 66.491 191.054 32.025 179.903 20.874"></polyline>
						</g>
					</svg></a>
				</div>
			</div>
		</div>
	);
}

function Bottom(){
	return (
		<div className="bottom">
			<div className="inner">
				<div className="fixedWidth">
					<div className="bottomLinks">
						<a href="https://www.wildapricot.com/terms-and-policies">Terms and Policies</a>
					</div>

					<div className="scrollToTopContainer grow">
						<a className="showBelow scrollToTop"><i className="far fa-arrow-to-top"></i> Scroll to top</a>
					</div>

					<div className="banners">
						<a href="https://www.wildapricot.com/security-policy-overview">
							<img alt="WildApricot Inc. Service Provider Level 1" title="WildApricot Inc. Service Provider Level 1" src="https://s.wildapricot.net/StaticImages/v100/Controls/Footer/pci-dss.png" />
						</a>
					</div>

				</div>
			</div>
		</div>
	);
}
